document.addEventListener('DOMContentLoaded', () => {
  const el      = document.querySelector('#policy-banner, #cookie-banner');
  const modal   = document.querySelector('#policy-modal, #cookie-modal');
  const btnAccept  = document.getElementById('accept-cookies');
  const btnDecline = document.getElementById('decline-cookies');
  const btnPrefs   = document.getElementById('cookie-settings');
  const btnSave    = document.getElementById('save-settings');
  const chkAnalytics = document.getElementById('analytics-consent');

  if (!el) return;

  const safeStorage = (() => {
    try {
      const k = '__tst__';
      window.localStorage.setItem(k, '1');
      window.localStorage.removeItem(k);
      return window.localStorage;
    } catch (e) {
      const mem = {};
      return {
        getItem: (k) => (k in mem ? mem[k] : null),
        setItem: (k, v) => { mem[k] = String(v); },
        removeItem: (k) => { delete mem[k]; }
      };
    }
  })();

  const CFG = {
    VERSION: '1',
    KEY_CONSENT: 'cookieConsent',
    KEY_ANALYTICS: 'analyticsConsent',
    KEY_VERSION: 'cookieConsentVersion'
  };

  const hasDecision = () => !!safeStorage.getItem(CFG.KEY_CONSENT);
  const getAnalyticsAllowed = () => safeStorage.getItem(CFG.KEY_ANALYTICS) === 'true';

  const showBar = () => el.classList.add('is-visible');
  const hideBar = () => el.classList.remove('is-visible');

  const showModal = () => {
    if (!modal) return;
    const saved = safeStorage.getItem(CFG.KEY_ANALYTICS);
    if (chkAnalytics && saved !== null) chkAnalytics.checked = saved === 'true';
    modal.style.display = 'block';
    document.documentElement.style.overflow = 'hidden';
    chkAnalytics?.focus();
  };
  const hideModal = () => { if (!modal) return; modal.style.display = 'none'; document.documentElement.style.overflow=''; };

  const applyConsent = (allowed) => {
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: allowed ? 'granted' : 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied'
      });
    }
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'cookie_consent_update', analytics_allowed: !!allowed });
    }
  };

  const persist = ({ consent, analytics }) => {
    safeStorage.setItem(CFG.KEY_CONSENT, consent);
    safeStorage.setItem(CFG.KEY_ANALYTICS, analytics ? 'true' : 'false');
    safeStorage.setItem(CFG.KEY_VERSION, CFG.VERSION);
    applyConsent(!!analytics);
    window.dispatchEvent(new CustomEvent('cookieconsentchange', { detail: { consent, analytics: !!analytics }}));
  };

  const needsReconsent = safeStorage.getItem(CFG.KEY_VERSION) !== CFG.VERSION;
  const debug   = new URLSearchParams(location.search).has('cookieDebug');
  const forced  = el.dataset.force === 'true';

  if (forced || debug || needsReconsent || !hasDecision()) {
    setTimeout(showBar, 50);
  } else {
    applyConsent(getAnalyticsAllowed());
  }

  btnAccept?.addEventListener('click', () => { persist({ consent: 'accepted', analytics: true }); hideBar(); });
  btnDecline?.addEventListener('click', () => { persist({ consent: 'declined', analytics: false }); hideBar(); });
  btnPrefs?.addEventListener('click', showModal);
  btnSave?.addEventListener('click', () => {
    const allowed = !!chkAnalytics?.checked;
    persist({ consent: 'custom', analytics: allowed });
    hideModal(); hideBar();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && modal?.style.display === 'block') hideModal(); });

  window.CookieConsent = {
    open: () => showModal(),
    reset: () => {
      safeStorage.removeItem(CFG.KEY_CONSENT);
      safeStorage.removeItem(CFG.KEY_ANALYTICS);
      safeStorage.removeItem(CFG.KEY_VERSION);
      showBar();
    },
    state: () => ({
      consent: safeStorage.getItem(CFG.KEY_CONSENT),
      analytics: safeStorage.getItem(CFG.KEY_ANALYTICS),
      version: safeStorage.getItem(CFG.KEY_VERSION)
    })
  };
});
